export const posthogPublicWriteKey = "phc_pQHv3h1aJtPwOfTsGcUOmlDScwqLvyEcKTtkf9wm7VL"
